import AdhdContent from './dsm/AdhdContent';

/**
 * DSM Reference page component
 */
export const DsmReference = (): JSX.Element => {
  return (
    <>
      <div style={{
        margin: 'auto',
        maxWidth: '1200px'
      }}>
        <div
          style={{
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '2rem',
            margin: '5px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}
        >
          <AdhdContent />
        </div>
      </div>
    </>
  );
};

export default DsmReference;
